module.exports = __webpack_public_path__ + "static/media/mag-logo4.78b38a52.png";